import React from "react";

import { ControlSection } from "../../../../../Common";

export interface INameContent {
  nameSectionName: string;
  nameSectionDescription: string;
}

interface INameProps {
  content: INameContent;
}

const Name: React.FC<React.PropsWithChildren<INameProps>> = (props) => {
  const { content } = props;

  return (
    <ControlSection
      name={content.nameSectionName}
      description={
        <div
          className="c-basic-info-form__name"
          dangerouslySetInnerHTML={{ __html: content.nameSectionDescription }}
        />
      }
    />
  );
};

export default Name;
